import { useState, useCallback, useEffect } from 'react';
import useSummaryAvailable from '@Containers/Summary/hooks/useSummaryAvailable';
import { SUMMARY_STATUS } from '@Containers/Summary/constants';
import { trackHowItWorksClick } from '@Containers/Summary/analytics';

function useSummaryContainer({ activeBreadcrumb, params, summaryStatus, fetchSummary, resetSummaryState }) {
  const { resultName, databaseId } = params;
  const [howItWorksPanelVisible, setHowItWorksPanelVisible] = useState(false);
  const toggleHowItWorksPanel = useCallback(() => {
    setHowItWorksPanelVisible((prevState) => {
      const nextState = !prevState;
      if (nextState) {
        trackHowItWorksClick();
      }
      return nextState;
    });
  }, []);

  const { isSummarySectionVisible, isSummaryAvailable, isReactionSummary } = useSummaryAvailable({ activeBreadcrumb });

  useEffect(() => {
    const { quickSearchItem, semanticResultName, textQuery } = activeBreadcrumb;
    if (isSummarySectionVisible && isSummaryAvailable && summaryStatus === SUMMARY_STATUS.NOT_REQUESTED) {
      fetchSummary({
        resultName,
        semanticResultName,
        databaseId,
        query: quickSearchItem?.content || textQuery,
        ...(isReactionSummary && { isReactionSummary }),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSummarySectionVisible, isSummaryAvailable, isReactionSummary, summaryStatus, resultName, databaseId]);

  useEffect(
    () => () => {
      resetSummaryState();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    isSummarySectionVisible,
    isSummaryAvailable,
    isReactionSummary,
    howItWorksPanelVisible,
    toggleHowItWorksPanel,
  };
}

export default useSummaryContainer;
